import React from 'react';
import {
    SvgIcon,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LogoutOutlineIcon } from 'resources/images/icons/logoutOutline.svg';
import { ModalPaper } from 'Components/Styles/Modals/ModalContainers';
import { ModalButton } from 'Components/Styles/Modals/Components';
import { useDispatch } from 'react-redux';
import { logout } from 'redux/reducers/authorization/actions';
import BaseModal from '../BaseModal';
import ModalHeader from '../ModalHeader';
import { closeLogoutModal } from 'redux/reducers/dashboard/actions';
import getWebsiteLink from 'utilities/getWebsiteLink';


function AccountModal({ onClose, ...props }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleLogout = () => {
        dispatch(logout());
        dispatch(closeLogoutModal());
    };

    return (
        <BaseModal
            aria-describedby="logout-modal-description"
            aria-labelledby="logout-modal-title"
            onClose={onClose}
            {...props}
        >
            <ModalPaper>
                <ModalHeader
                    icon={<SvgIcon component={LogoutOutlineIcon} color="primary" viewBox="0 0 88 88" />}
                    title={t('logoutModal.title')}
                    subtitle={t('logoutModal.description')}
                />
                <ModalButton variant="outlined" color="primary" size="small" onClick={onClose}>
                    {t('logoutModal.cancelButtonText')}
                </ModalButton>
                <ModalButton variant="contained" color="primary" size="small" onClick={handleLogout}>
                    {t('logoutModal.confirmButtonText')}
                </ModalButton>
            </ModalPaper>
        </BaseModal>
    );
}

export default AccountModal;
